
import { wxshare, getaccessstatus } from '@/api/resetApi.js'

const state = {
  expertUserName:'',
  expertUserId:'',
  expertToken:'',
  getChildData: [],
  checkList: [],
  pasturelist: [],
  pasturedata: [],
  laboratorydata: [],
  laboratorylist: [],
  swinedata: [],
  swinelist: [],
  rabiddata: [],
  rabidlist: [],
  blueeardata: [],
  blueearlist: []
}


const mutations = {
  // 同步方法
  changeNum(state,data) {}

}

const actions = {
  // 浏览记录
  async getaccessstatus({ commit, state }, userInfo) {
    const { user_id, page_type } = userInfo
    // let data = new FormData();
    // data.append('url',url)
    let data = JSON.stringify({
      user_id: user_id,
      page_type: page_type
    })
    let res = await getaccessstatus(data)
    console.log('浏览记录',res)
  },
  
  async wxshare({ commit, state }) {
    let url = window.location.href.split('#')[0];
    let data = new FormData();
    data.append('url',url)
    let res = await wxshare(data)
    console.log('res11111111=',res)
    try {
      if (res.data.code === 1) {
        const { data } = res
        return data
      }
    } catch (error) {
      console.log(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
